import { useStaticQuery, graphql } from 'gatsby'

export const useWeatherData = () => {
    const { weather } = useStaticQuery(
        graphql`
            query WeatherData {
                weather {
                    main {
                        temp
                    }
                    wind {
                        deg
                        speed
                    }
                }
            }
        `
    )

    return weather
}
